import React from 'react';
import '../shared.css';
import { FaFacebook, FaInstagram, FaEnvelope, FaSquareVimeo } from 'react-icons/fa6';
import SocialIcon from './SocialIcon';

const HeroSection = () => {
  return (
    <section className="hero" role="region" aria-labelledby="hero-heading">
      <div className="hero-title-wrapper">
        <h1 id="hero-heading" className="hero-title">
          DANG GOOD LEATHER
        </h1>
      </div>

      <div className="hero-content-row">
        <div className="hero-logo-container">
          <img
            src="/images/hero-art-photo.jpg"
            alt="Artistic hero image featuring leatherwork by Dang Good Leather"
            className="hero-logo"
          />
        </div>
        <div className="hero-text-container">
          <p className="hero-description">
            Jenny Dang of Dang Good Leather is a queer, enby-femme Asian artist who
            specializes in handcrafted custom-made leather goods. Based in Maryland,
            they hand mold each rose, hand paint each dragon, and hand stitch each bag
            to provide one-of-a-kind accessories for all gentlefolk, misfits, and weirdos.
          </p>
          <div className="hero-social">
            <SocialIcon
              href="https://www.facebook.com/profile.php?id=61564308804072"
              label="Facebook"
              Icon={FaFacebook}
            />
            <SocialIcon
              href="https://www.instagram.com/danggoodleather/"
              label="Instagram"
              Icon={FaInstagram}
            />
            <SocialIcon
              href="https://venmo.com/dangjennydang"
              label="Venmo"
              Icon={FaSquareVimeo}
            />
            <SocialIcon
              href="mailto:boop@danggoodleather.com"
              label="Email"
              Icon={FaEnvelope}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
